__turbopack_context__.v({
  "component": "style-module-scss-module__sADZ-q__component",
  "custom-tooltip-position": "style-module-scss-module__sADZ-q__custom-tooltip-position",
  "exp": "style-module-scss-module__sADZ-q__exp",
  "share": "style-module-scss-module__sADZ-q__share",
  "thumbnails": "style-module-scss-module__sADZ-q__thumbnails",
});
